import axios, { BUSINESS_PAYMENT_PREFIX } from 'src/clients/axios';
import {
  PaymentCheckoutPortalCustomColorResponse,
  PaymentCheckoutPortalCustomColorUpdateRequest,
  PaymentCheckoutPortalCustomColorUpdateResponse,
} from 'src/models/PaymentCheckout';

export function getPaycheckoutTheme(data?: any) {
  return axios.request<PaymentCheckoutPortalCustomColorResponse>({
    method: 'get',
    url: `${BUSINESS_PAYMENT_PREFIX}/payment-checkout/personalize/colorscheme`,
    data,
  });
}

export function updatePaycheckoutTheme(
  data: PaymentCheckoutPortalCustomColorUpdateRequest,
) {
  return axios.request<PaymentCheckoutPortalCustomColorUpdateResponse>({
    method: 'put',
    url: `${BUSINESS_PAYMENT_PREFIX}/payment-checkout/personalize/colorscheme`,
    data,
  });
}
